import React, { useState } from 'react';
import { useFormik } from 'formik';
import { useApp } from 'providers';
import { useClickTracking } from 'hooks';
import { TRACKING_CLICKS } from 'api';
import { registerValidationSchema } from './validationSchema';
import { RegisterFormView } from './RegisterFormView';

export const RegisterForm = (): React.ReactElement => {
  const { register } = useApp();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const track = useClickTracking(TRACKING_CLICKS.INSCRIPTION);
  const {
    errors,
    values: { email, password, confirmPassword, cgu },
    isSubmitting,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
  } = useFormik({
    initialValues: {
      email: '',
      password: '',
      confirmPassword: '',
      cgu: false,
    },
    validationSchema: registerValidationSchema,
    onSubmit: (values, { setSubmitting, setFieldError }) => {
      register(values.email, values.password)
        .then(track)
        .catch(r => {
          if (typeof r === 'string') {
            setErrorMessage(r);
          } else if (typeof r === 'object') {
            Object.keys(r).forEach(k => {
              const formKey = k === 'newPassword' ? 'password' : k;
              const error = r[k].join ? r[k].join(', ') : r[k];
              setFieldError(formKey, error);
            });
          }
        })
        .finally(() => setSubmitting(false));
    },
  });

  return (
    <RegisterFormView
      email={email}
      password={password}
      confirmPassword={confirmPassword}
      cgu={cgu}
      isSubmitting={isSubmitting}
      errorMessage={errorMessage}
      touched={touched}
      errors={errors}
      setFieldValue={setFieldValue}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
};
